import { render } from "./HelloWorld.vue?vue&type=template&id=25d525f8&scoped=true"
import script from "./HelloWorld.vue?vue&type=script&lang=js"
export * from "./HelloWorld.vue?vue&type=script&lang=js"

import "./HelloWorld.vue?vue&type=style&index=0&id=25d525f8&scoped=true&lang=css"

import exportComponent from "/home/runner/work/vue_restaurants/vue_restaurants/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-25d525f8"]])

export default __exports__